export type Bonus = {
  number: number;
  title: string;
  tagline: string;
  image: string;
  body: string[];
  listLabel?: string;
  items?: string[];
  formula?: string;
  note?: string;
  value: string;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "30 Educational Facelift Case Exercises",
    tagline: "30 structured opportunities to practice your case-review framework.",
    image: "https://cdn.magicpatterns.com/uploads/e6kxse6heDAfpkuzwd3F21/BONUS_1_FACELIFT-EN.png",
    body: [
      "Receive a collection of educational case exercises designed to help you practice organizing observations, identifying questions, and documenting learning points.",
      "Each exercise follows a consistent format:",
    ],
    formula: "Case → Observe → Organize → Review → Reflect",
    note: "The exercises are designed for educational discussion and structured learning. They are not validated patient-specific surgical recommendations.",
    value: "$47",
  },
  {
    number: 2,
    title: "The 10-Minute Facelift Review™",
    tagline: "A condensed framework for shorter study sessions.",
    image: "https://cdn.magicpatterns.com/uploads/oEsdvSnj3uRFbYdfsmH3P9/BONUS_2_FACELIFT-EN.png",
    body: [
      "Sometimes you don't have time to work through every part of a comprehensive educational review. That's why I created a shorter version of the framework.",
    ],
    listLabel: "Use it to organize a focused study session around five activities",
    items: [
      "Review the available case information.",
      "Identify the most relevant observations.",
      "Record your main questions.",
      "Identify the references you need to consult.",
      "Document the most important learning points.",
    ],
    formula: "One case. Ten minutes. A more focused educational review.",
    value: "$37",
  },
  {
    number: 3,
    title: "The Facelift Complication Review Atlas",
    tagline: "A structured way to study challenging scenarios.",
    image: "https://cdn.magicpatterns.com/uploads/okdWsEMycHVNj8YSCLPVue/BONUS_3_FACELIFT-EN.png",
    body: ["This educational collection helps you organize the review of complications and difficult case discussions."],
    listLabel: "For each scenario, you'll find a structured worksheet covering",
    items: [
      "Scenario summary",
      "Information available",
      "Questions requiring investigation",
      "Relevant educational references",
      "Factors discussed in the source material",
      "Documentation prompts",
      "Reflection questions",
      "Key learning points",
    ],
    note: "The aim is to help you study challenging scenarios systematically, not to replace clinical guidelines or professional judgment.",
    value: "$47",
  },
  {
    number: 4,
    title: "The Surgeon's Facelift Review Cards",
    tagline: "One card. One question. One focused learning session.",
    image: "https://cdn.magicpatterns.com/uploads/2XJki3CYTknP4Xzpc4fEX1/BONUS_4_FACELIFT-EN.png",
    body: ["These printable educational cards provide prompts for individual study or professional discussion."],
    listLabel: "Examples include",
    items: [
      "“Which case characteristics deserve closer review?”",
      "“What information is missing from this educational case?”",
      "“Which anatomical concepts should I revisit?”",
      "“What questions remain unanswered?”",
      "“Which references could help clarify this concept?”",
      "“What did I learn from comparing these two cases?”",
    ],
    note: "Use the cards to create short, focused study sessions or to structure discussions with colleagues.",
    value: "$37",
  },
  {
    number: 5,
    title: "The 30-Day Facelift Case Review Challenge™",
    tagline: "Build a more consistent educational review habit.",
    image: "https://cdn.magicpatterns.com/uploads/dPG9SPHifoGjzV6xJ42qoE/BONUS_5_FACELIFT-EN.png",
    body: [
      "This 30-day calendar helps you incorporate structured case review into your professional learning routine. Each day includes a small educational activity.",
    ],
    formula: "One Case → One Exercise → One Reflection → One Learning Point",
    listLabel: "You'll receive",
    items: [
      "A 30-day learning calendar",
      "Daily review prompts",
      "Weekly reflection worksheets",
      "A progress tracker",
      "A record of topics reviewed",
      "A final learning summary",
      "A plan for continuing your educational review routine",
    ],
    note: "The objective is to create a repeatable learning habit, not to certify surgical competence or guarantee clinical outcomes.",
    value: "$29",
  },
];
